import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { DELETE_USER } from './actionTypes';
import { deleteUserSuccessful, deleteUserFailed } from './actions';

// Include call API
import { getUsersAPI } from "../../../api/users";
import {logoutUser} from "../../actions"
const usersAPI = getUsersAPI();

// Is user register successfull then direct plot user in redux.
function* deleteUser({ payload: { username, name, token, history } }) {
    try {
        const response = yield call(usersAPI.deleteUser, name, token);
     
        
        if(username===name){
            console.log("hola")
            yield put(logoutUser(history));
        }else{
            yield put(deleteUserSuccessful(response.message));
           history.go()
        }

    } catch (error) {
        yield put(deleteUserFailed(error));
    }
}

export function* watchUserDelete() {
    yield takeEvery(DELETE_USER, deleteUser);
}

function* deleteAccountSaga() {
    yield all([fork(watchUserDelete)]);
}

export default deleteAccountSaga;